import './App.scss';

import React, { FC } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'app/theme/ThemeContext';

import router from 'app/configs/routesConfig';
import store from 'app/store';

const App: FC = () => {
  return (
    <React.StrictMode>
      <HelmetProvider>
        <ThemeProvider>
          <Provider store={store}>
            <Helmet>
              <title>Unigine Id Service</title>
            </Helmet>
            <RouterProvider router={router} />
          </Provider>
        </ThemeProvider>
      </HelmetProvider>
    </React.StrictMode>
  );
};

export default App;
